export const isGlobalErrorsMatchesList = (globalErrors, errorCodeList) => (
  globalErrors.some(({ code }) => errorCodeList.includes(code))
);

export const convertGlobalErrors = (globalErrors, map) => (
  globalErrors.map(({ code, params = {} }) => ({ id: map?.[code] || code, params }))
);
